import { render, staticRenderFns } from "./RentalProperties.vue?vue&type=template&id=1fdfb528&scoped=true"
import script from "./RentalProperties.vue?vue&type=script&lang=js"
export * from "./RentalProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdfb528",
  null
  
)

export default component.exports